import { EmptyCompactPanelText } from "styles/text";
import { selectTournamentsAndToursByStatus } from "selectors/Tournament";
import { selectAllTours } from "selectors/Tour";
import { Tour } from "model/Tour/Tour";
import { CompactTourList } from "./CompactTourList";
import { useAppSelector } from "app/hooks";

interface Props {
  amount: number;
}

export const CompactUpcomingTours = ({ amount }: Props) => {
  // todo - bad to resolve all tours like this
  const tours = useAppSelector((state) => selectAllTours(state));

  const ongoingTours = useAppSelector(
    (state) =>
      selectTournamentsAndToursByStatus(
        state,
        [],
        tours,
        "Ongoing",
        "Ascending"
      )
        .filter((t) => t.type === "Tour")
        .map((t) => t.data) as Tour[]
  );

  const upcomingTours = useAppSelector(
    (state) =>
      selectTournamentsAndToursByStatus(
        state,
        [],
        tours,
        "Upcoming",
        "Ascending"
      )
        .filter((t) => t.type === "Tour")
        .map((t) => t.data) as Tour[]
  );

  const ongoingUpcomingTourIds = ongoingTours
    .concat(upcomingTours)
    .map((t) => t.id);

  if (ongoingUpcomingTourIds.length === 0) {
    return <EmptyCompactPanelText>No Ongoing Tours</EmptyCompactPanelText>;
  }

  return <CompactTourList tourIds={ongoingUpcomingTourIds.slice(0, amount)} />;
};
